import './VerifyCoverageView.css'
import Suggestion from '../../Components/Suggestion/Suggestion'
import SuggestionModel from '../../Models/SuggestionModel'
import PlaceDetailsModel from '../../Models/PlaceDetailsModel'
import { useContext, useState, useEffect } from 'react'
import { NavigationNode } from '../../Services/Navigation'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ViewType from '../../Types/ViewType'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import API from '../../Services/API'

const VerifyCoverageView = () => {
	let context = useContext(ConfiguratorContext)

	let [suggestion, setSuggestion] = useState("")
	let [suggestions, setSuggestions] = useState<SuggestionModel[]>([])
	let [place, setPlace] = useState<SuggestionModel | null>(null)
	let [suggestionsHidden, setSuggestionsHidden] = useState(true)
	let [placeDetails, setPlaceDetails] = useState<PlaceDetailsModel | null>(null)
	let [isCovered, setIsCovered] = useState<boolean | undefined>(undefined)
	let [coverageStatus, setCoverageStatus] = useState<string | undefined>("")
	let [coverageSubStatus, setCoverageSubStatus] = useState<string | undefined>("")
	let [coverageClass, setCoverageClass] = useState<string | undefined>("")
	let [coverageSubClass, setCoverageSubClass] = useState<string | undefined>("")

	context.validateVerifyCoverage = () => {
		if (place === null) {
			return false;
		}
		else {
			context.zone = place?.id
		}
		return true;
	}

	useEffect(() => {
		(() => {
			if (isCovered) {
				setCoverageStatus("Ti confermiamo la copertura tramite ponte radio dell'indirizzo indicato.")
				setCoverageSubStatus("Verrà eseguita una ulteriore verifica per la copertura FTTC/FTTH.");
				setCoverageClass("text-green");
				setCoverageSubClass("text-green");
			}
			else {
				if (isCovered === undefined) {
					setCoverageClass("hidden");
					setCoverageSubClass("hidden");
				}
				else {
					setCoverageClass("text-red");
					setCoverageSubClass("text-green");
				}
				setCoverageStatus("Non è presente la copertura tramite ponte radio.");
				setCoverageSubStatus("Verrà eseguita una verifica per la copertura FTTC/FTTH.");
			}

		})()
		return () => { }
	}, [placeDetails])

	useEffect(() => {
		(async () => {
			if (place != null) setSuggestion(place.name);
			setSuggestionsHidden(true);
			if (place?.id != null) {
				let res = await API.getplaceDetailsAsync(place?.id)
				if (res.success) {
					context.province = res.data.province;
					context.common = res.data.municipality;
					context.cap = res.data.cap;
					context.address = res.data.address;
					context.civicNumber = res.data.civicNumber;
					context.isCovered = res.data.is_covered;
					setPlaceDetails(res.data);
					setIsCovered(res.data.is_covered);
				}
			}

		})()
		return () => { }
	}, [place])

	async function onInputChange(c: any) {
		setSuggestion(c.target.value);
		setSuggestionsHidden(false);
		if (c.target.value !== "") {
			setSuggestions(await (await API.getCoverageSuggestionsAsync(c.target.value)).data);
		}
	}

	function onInputBlur() {
		setSuggestionsHidden(true);
	}

	function renderSuggestions() {
		if (suggestionsHidden) {
			return [];
		}

		return suggestions.map((x, index) => {
			return (
				<div key={index} className='verify-coverage-suggestion' onMouseDown={c => suggestionClick(x)}>
					<Suggestion place={x.name} />
				</div>
			)
		});
	}

	async function suggestionClick(x: SuggestionModel) {
		setPlace(x)
	}

	return (
		<ImageLayout src="../assets/coverage.png">
			<div className='verify-coverage-main '>
				<div className="verify-coverage-title">Verifica la copertura</div>
				<div className="verify-coverage-input-container">
					<input onChange={c => onInputChange(c)} value={suggestion} onBlur={() => onInputBlur()} className="verify-coverage-input" />
					<div className='verifiy-coverage-suggestions-container'>
						{renderSuggestions()}
					</div>
				</div>
			</div>
			<div>
				<div className={"coverage-text " + coverageClass}>{coverageStatus} </div>
				<div className={"coverage-subtext " + coverageSubClass}>{coverageSubStatus} </div>
			</div>
		</ImageLayout>
	)
}

const VerifyCoverageNode: NavigationNode = {
	content: () => <VerifyCoverageView />,
	percentage: 0,
	previous: (_: Configuration) => undefined,
	next: (_: Configuration) => ViewType.homeUse
}

export default VerifyCoverageNode